import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import css from '../css/recommended-next-steps.m.css';
const factory = create({
    theme
}).properties();
export const RNSRow = factory(({ properties, middleware: { theme } }) => {
    const { domain, functionalArea, reading, quiz, action, header = false } = properties();
    const { row, headerClass } = theme.classes(css);
    const role = header ? 'columnheader' : 'cell';
    const sort = header ? 'none' : null;
    const aria = { sort };
    return v('div', { role: 'row', classes: [row, header ? headerClass : null] }, [
        v('div', { role, ...formatAriaProperties(aria) }, [domain]),
        v('div', { role, ...formatAriaProperties(aria) }, [functionalArea]),
        v('div', { role, ...formatAriaProperties(aria) }, [reading]),
        v('div', { role, ...formatAriaProperties(aria) }, [quiz]),
        v('div', { role, ...formatAriaProperties(aria) }, [action])
    ]);
});
export default RNSRow;
